const PREFIX = '56 9';

/** Últimos 8 dígitos locales (sin 56 ni el 9 de móvil). */
export function chileLocalDigits(value) {
  let digits = String(value || '').replace(/\D/g, '');
  if (digits.startsWith('569')) digits = digits.slice(3);
  else if (digits.startsWith('56')) {
    digits = digits.slice(2);
    if (digits.startsWith('9')) digits = digits.slice(1);
  } else if (digits.startsWith('9') && digits.length >= 9) {
    digits = digits.slice(1);
  }
  return digits.slice(0, 8);
}

/** Muestra `56 9` y agrupa el resto: `56 9 1234 5678`. */
export function formatChileMobile(value) {
  const local = chileLocalDigits(value);
  const a = local.slice(0, 4);
  const b = local.slice(4, 8);
  if (!a) return PREFIX;
  if (!b) return `${PREFIX} ${a}`;
  return `${PREFIX} ${a} ${b}`;
}

/** Dígitos para guardar / WhatsApp: `56912345678`. */
export function chileMobileDigits(value) {
  const local = chileLocalDigits(value);
  return local.length === 8 ? `569${local}` : local ? `569${local}` : '';
}

export function chileMobileCompleto(value) {
  return chileLocalDigits(value).length === 8;
}
